import * as eventRoutines from '../eventRoutines';
import * as ls from '../../../services/localStorage';
import * as paths from '../../../Providers/paths';
import * as rootSelectors from '../../../selectors/root';
import * as scheduleRoutines from '../../Schedule/scheduleRoutines';
import * as toastRoutines from '../../../sagas/routines/toastRoutines';

import {all, call, put, select, takeEvery, takeLatest} from 'redux-saga/effects';
import  { deleteFileFromStorageSaga } from '../../../sagas/filesSaga';
import { getActiveEventHero } from '../selectors';
import { push } from 'connected-react-router';
import { rsf } from '../../../globals/firebase';
import { sendStringSaga } from '../../../sagas/filesSaga';
import { setToastError } from '../../../sagas/routines/toastRoutines';
import api from '../../../services/api/';
import get from 'lodash/get'
import config from '../../../globals/config'
import { extractFileTypeFromBase64 } from '../../../helpers/fileTypeRegex';
import * as _ from 'lodash'
export function* saveEventHeroImageSaga(action) {
    yield put(
        toastRoutines.triggerToast({
            content: 'Updating event hero image...',
            options: {
                autoClose: false,
                type: 'info',
            },
        }),
    );
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    const base64Image = action.payload;
    const fileType = extractFileTypeFromBase64(base64Image);
    const activeEventHero = yield select(getActiveEventHero);
    const filePath = paths.storage_event_image(activeEvent, `eventBackground.${fileType}`);

    try {
        if (activeEventHero) yield call(deleteFileFromStorageSaga, activeEventHero, `/ContainerApp/${activeEvent}`);
        const downloadablePath = yield call(sendStringSaga, { filePath, imageURL: base64Image });
        yield call(rsf.database.patch, paths.event_config_fb(activeEvent), { imageURL: downloadablePath });
        yield put(toastRoutines.dismissToast());
        yield put(eventRoutines.saveEventHeroImage.success({ event_id: activeEvent, heroImage: downloadablePath }));
        yield put(toastRoutines.setToastSuccess('Event hero image updated!'));
    } catch (error) {
        yield put(toastRoutines.dismissToast());
        yield put(eventRoutines.saveEventHeroImage.failure(error));
    }
}

export function* fetchEventInformationFromFBSaga(event_id) {
    let res;
    try {
        res = yield call(rsf.database.read, paths.event_config_fb(event_id));
        yield put(
            eventRoutines.fetchEventInformationFromFB.success({
                event_id,
                ...res,
            }),
        );
    } catch (error) {
        yield put(eventRoutines.fetchEventInformationFromFB.failure(error));
    }
}

export function* fetchActiveModulesSaga(action) {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    try {
        let res = yield call(rsf.database.read, paths.moduleConfig(activeEvent, 'activeModules'));
        yield put(eventRoutines.fetchActiveModules.success(res));
    } catch (error) {
        yield put(eventRoutines.fetchActiveModules.failure(error));
    }
}
export function* updateActiveModuleSaga(action) {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    const { moduleName, status } = action.payload;
    const update = {
        [moduleName]: status === true ? true : false,
    };

    try {
        yield call(rsf.database.patch, paths.moduleConfig(activeEvent, 'activeModules'), update);
        yield put(eventRoutines.updateActiveModule.success({ moduleName, status }));
    } catch (error) {
        yield put(eventRoutines.updateActiveModule.failure(error));
    }
}

//Used to enable/disable the channels module (within the Inbox module)
export function* updateChannelsModuleSaga(action) {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    let isEnabled = action.payload === true ? true : false;
    try {
        yield call(rsf.database.patch, paths.moduleConfig(activeEvent, 'inbox', 'chat'), { isEnabled });
        yield put(eventRoutines.updateChannelsModule.success({ isEnabled: action.payload }));
    } catch (error) {
        yield put(eventRoutines.updateChannelsModule.failure(error));
    }
}

//Used to enable/disable the peer to peer module (within the Inbox module)
export function* updatePeerToPeerModuleSaga(action) {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    let isEnabled = action.payload === true ? true : false;
    try {
        yield call(rsf.database.patch, paths.moduleConfig(activeEvent, 'inbox', 'peerToPeer'), { isEnabled });
        yield put(eventRoutines.updatePeerToPeerModule.success({ isEnabled: action.payload }));
    } catch (error) {
        yield put(eventRoutines.updatePeerToPeerModule.failure(error));
    }
}

//Used to enable/disable video chat for peer to peer module (within the Inbox module)
export function* updatePeerToPeerVideoChatSaga(action) {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    let isVideoChatEnabled = action.payload === true ? true : false;
    try {
        yield call(rsf.database.patch, paths.moduleConfig(activeEvent, 'inbox', 'peerToPeer'), { isVideoChatEnabled });
        yield put(eventRoutines.updatePeerToPeerVideoChat.success({ isVideoChatEnabled: action.payload }));
    } catch (error) {
        yield put(eventRoutines.updatePeerToPeerVideoChat.failure(error));
    }
}

export function* fetchSessionsForEventSaga() {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    yield put(eventRoutines.fetchSessionsForEvent.request(true)); //Indicates loading
    let res = yield call(api.fetchSessionsForEventGraphQl, activeEvent);
    yield put(scheduleRoutines.publishImportedSessions.success(false));
    yield put(eventRoutines.fetchSessionsForEvent.success(res.data.response.data.eventSession));
    yield put(eventRoutines.fetchSessionsForEvent.request(false)); //Indicates loading
}

function* processRegistrantsBatchSaga(payload) {
    const { itemsPerPage, page } = payload;
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    try {
        let batch = yield call(api.fetchRegistrantsBatchForEvent, activeEvent, page, itemsPerPage);
        yield put(eventRoutines.fetchRegistrantsBatchForEvent.success(batch.data.response));
    } catch (error) {
        yield put(eventRoutines.fetchRegistrantsBatchForEvent.error(error));
    }
}
export function* fetchRegistrantsForEventSaga(payload) {
    //Obtain active event
    try {
        //Default values
        let itemsPerPage = 75;
        let totalPages = 1;
        //Now that we now how many total items, and how many pages of data, we can call for the invitee info in batches
        yield all(
            [...Array(totalPages)].map((val, idx) => {
                let page = idx + 1;
                //Retrieve the batch of invitees for each page, with consistant itemsPerPage from above
                return call(processRegistrantsBatchSaga, {
                    itemsPerPage,
                    page,
                });
            }),
        );
        yield put(eventRoutines.fetchRegistrantsForEvent.success());
    } catch (error) {
        yield put(eventRoutines.fetchRegistrantsForEvent.failure(error));
    }
}
//Only used for initial events loading
export function* fetchEventsSaga(payload) {

    try {
        let res = yield call(api.listEvents, ls.getCCValues().CC_USER_ID, {
            page:1,
            resultsPerPage:10,
            query: ''
        });
        let events = get(res, 'data')
        yield put(eventRoutines.fetchEvents.success(events));
    } catch (error) {
        console.error('Error fetching events');
        yield put(eventRoutines.fetchEvents.failure(error));

        yield put(push('/associations'));
        yield put(setToastError('Error fetching list of events'));
    }
}

export function* toggleEventInActiveListSaga(action) {
    let path = '';

        path = `/ContainerApp/v1_0/${config.REACT_APP_ACTIVE_MASTER_EVENTS_NODE_FIREBASE}`;

    const { eventAppEnabled, id, name } = action.payload;
    try {
        yield call(rsf.database.update, `${path}/${id}`, eventAppEnabled ? name : null);
        yield put(
            eventRoutines.togglePresenceOfEventInActiveEventsList.success({
                eventAppEnabled,
                id,
                name,
            }),
        );
    } catch (error) {
        yield put(eventRoutines.togglePresenceOfEventInActiveEventsList.failure(error));
    }
}

export function* fetchSitePagesForEventSaga(payload) {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    try {

        //Obtain first batch and meta data
        const itemsPerPage = 5;
        let res = yield call(api.fetchSitePages, activeEvent, 1, itemsPerPage);
        let additionalCalls = [];
        let data = []
        const meta = _.get(res, 'data.meta')
        const totalPages = _.get(meta, 'totalPages')

        //Populate data array with data from first response
        data = [...data, ...res.data.data]

        //If there are remaining results to obtain, lets loop through and populate array of additional calls to make
        if(totalPages > 1 ){
            for(let i = 2; i <= totalPages; i++){
                additionalCalls.push(call(api.fetchSitePages, activeEvent, i, itemsPerPage))
            }
            const additionalRes = yield all(additionalCalls)
            //Let's populate data array with all results
            additionalRes.forEach(res => data = [...data, ...res.data.data])

        }
        //Sort sitepages by name
        const sorted = data.sort((a, b) => {
            return a.attributes.name.localeCompare(b.attributes.name, undefined, {
                numeric: true,
                sensitivity: 'base'
            })
        });
        // const sorted = _.orderBy(data, o => o.attributes.name.toLowerCase(), 'asc');
        yield put(eventRoutines.fetchSitePagesForEvent.success(sorted));
        yield put(eventRoutines.fetchSitePagesForEvent.success(sorted));
    } catch (error) {
        yield put(eventRoutines.fetchSitePagesForEvent.failure(error));
    }
}
export function* clearSpecificEventDataSaga(action) {
    try {
        yield call(rsf.database.delete, `${paths.eventPath(action.event)}/moduleConfiguration`);
        yield call(rsf.database.delete, `${paths.eventPath(action.event)}/appConfiguration`);
        yield call(rsf.database.delete, `${paths.eventPath(action.event)}/data`);
        yield call(
            rsf.database.delete,
            `/ContainerApp/v1_0/${config.REACT_APP_ACTIVE_MASTER_EVENTS_NODE_FIREBASE}/${action.event}`,
        );
    } catch (error) {
        alert('failed to clear!');
    }
}
export function* clearSpecificEventDiscoverDataSaga(action) {
    try {
        yield call(rsf.database.delete, `${paths.eventPath(action.event)}/moduleConfiguration/discover`);
    } catch (error) {}
}

export function* fetchActiveMasterEventsFirebaseSaga(node_id) {
    if (node_id) {
        try {
            let res = yield call(rsf.database.read, `/ContainerApp/v1_0/${node_id}`);
            yield put(eventRoutines.fetchActiveMasterEventsFirebase.success(res));
        } catch (error) {
            yield put(eventRoutines.fetchActiveMasterEventsFirebase.failure(error));
        }
    }
}

export function* fetchEventSaga(action) {
    try {
        let res = yield call(api.getEvent, action.payload);
        let events = res.data;
        yield put(eventRoutines.fetchEvent.success(events));
    } catch (error) {
        yield put(eventRoutines.fetchEvent.failure(error));
        yield put(setToastError('Error fetching  event'));
    }
}


function* fetchEventInviteesCountsSaga(){
    const eventId = yield select(rootSelectors.selectActiveEventId);
    try {
        const res = yield call(api.fetchInviteeCountsForEvent, eventId)
        yield put (eventRoutines.fetchEventInviteesCounts.success(res.data.data))
    }
    catch(error){
        yield put (eventRoutines.fetchEventInviteesCounts.failure(error))
    }
}

export default function* rootSaga() {
    yield takeEvery(eventRoutines.fetchEvent.TRIGGER, fetchEventSaga);

    yield takeEvery(eventRoutines.fetchEvents.TRIGGER, fetchEventsSaga);
    yield takeEvery(eventRoutines.saveEventHeroImage.TRIGGER, saveEventHeroImageSaga);
    yield takeEvery(eventRoutines.fetchEventInformationFromFB.TRIGGER, fetchEventInformationFromFBSaga);
    yield takeEvery(eventRoutines.fetchActiveModules.TRIGGER, fetchActiveModulesSaga);
    yield takeEvery(eventRoutines.fetchSitePagesForEvent.TRIGGER, fetchSitePagesForEventSaga);
    yield takeEvery(eventRoutines.togglePresenceOfEventInActiveEventsList.TRIGGER, toggleEventInActiveListSaga);
    yield takeEvery(eventRoutines.updatePeerToPeerModule.TRIGGER, updatePeerToPeerModuleSaga);
    yield takeEvery(eventRoutines.updatePeerToPeerVideoChat.TRIGGER, updatePeerToPeerVideoChatSaga);
    yield takeEvery(eventRoutines.updateChannelsModule.TRIGGER, updateChannelsModuleSaga);
    yield takeEvery(eventRoutines.updateActiveModule.TRIGGER, updateActiveModuleSaga);
    yield takeEvery(eventRoutines.fetchSessionsForEvent.TRIGGER, fetchSessionsForEventSaga);
    yield takeEvery(eventRoutines.fetchRegistrantsForEvent.TRIGGER, fetchRegistrantsForEventSaga);
    yield takeEvery('CLEAR_SPECIFIC_EVENT_DATA', clearSpecificEventDataSaga);
    yield takeEvery('CLEAR_SPECIFIC_EVENT_DISCOVER_DATA', clearSpecificEventDiscoverDataSaga);
    yield takeLatest(eventRoutines.fetchEventInviteesCounts, fetchEventInviteesCountsSaga);

}

